<template>
<x-y-chart
  :data-config="newDataConfig"
  :unit-prop="unitProp"
  chart-type="line"
  :stack-type="0"
  :download-name="downloadName"
  :chart-min-height="chartMinHeight"
  chart-height="auto"
  selected-change-with-data-changed
  need-resize
/>
</template>

<script>
import XYChart from '../../DataChart/XYChart'

export default {
  name: 'WeatherChart',
  components: {XYChart},
  props: {
    dataConfig: {
      required: true,
      type: Object
    },
    unitProp: {
      required: true,
      type: String
    },
    factorGroupMap: {
      required: true,
      type: Object
    },
    downloadName: {
      type: String
    },
    chartMinHeight: {
      type: String
    }
  },
  data: () => ({
    newDataConfig: null
  }),
  methods: {
    buildNewDataConfig (dataConfig) {
      let {dimensions, seriesMap} = dataConfig

      let newSeriesMap = {}
      let newDimensions = dimensions.reduce((list, dimension) => {
        let dimensionId = dimension.id

        if (dimensionId === '1012') {
          let newId = '1012-1013'
          list.push({
            id: newId,
            name: '风速风向',
            stdUnit: dimension.stdUnit,
            displayUnit: dimension.displayUnit,
            weight: dimension.weight,
            getTooltip: (dimension, marker, seriesName, value, seriesId, data, unitProp) => [{
              marker,
              seriesName: '风速',
              value: Number.isFinite(value) ? value : '--',
              unit: dimension[unitProp]
            }, {
              marker,
              seriesName: '风向',
              value: data && Number.isFinite(data.windDirect) ? data.windDirect : '--',
              unit: '°'
            }],
            seriesParam: {
              type: 'line',
              symbol: `image://data:image/svg+xml;base64,${btoa(`<svg viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-50.000000, -60.000000)" fill-rule="nonzero" fill="#795548"><polygon transform="translate(58.000000, 68.000000) scale(1, -1) rotate(90.000000) translate(-58.000000, -68.000000) " points="50 73 55.3076923 68 50 63 66 68"></polygon></g></g></svg>`)}`,
              symbolSize: 20,
              color: '#795548',
              showAllSymbol: true,
              z: 3
            }
          })

          let windDirect = dimensions.find(dimension => dimension.id === '1013')

          if (windDirect) {
            let windDirectDataMap = seriesMap['1013']
            let windSpeedDataMap = seriesMap[dimensionId]
            let newDataMap = {}

            for (let key in windSpeedDataMap) {
              let newData = newDataMap[key] = {
                ...windSpeedDataMap[key]
              }

              let windDirectData = windDirectDataMap[key]

              if (windDirectData) {
                let {value} = windDirectData
                newData.symbolRotate = 180 - windDirectData.value
                newData.windDirect = value
              }
            }

            newSeriesMap[newId] = newDataMap
          } else {
            newSeriesMap[newId] = seriesMap[dimensionId]
          }
        } else if (dimensionId !== '1013') {
          list.push(dimension)
          newSeriesMap[dimensionId] = seriesMap[dimensionId]
        }

        return list
      }, [])

      this.newDataConfig = Object.freeze({
        ...dataConfig,
        dimensions: newDimensions,
        seriesMap: newSeriesMap
      })
    }
  },
  watch: {
    dataConfig: {
      immediate: true,
      handler (dataConfig) {
        this.buildNewDataConfig(dataConfig)
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Data/ChartWrapper/WeatherChart.vue